import { state } from '@angular/animations';
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import storageService from '@shared/storage/storageService';
import { Observable } from 'rxjs';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.checkLogin(state.url,next);
  }

  checkLogin(url: string,route : ActivatedRouteSnapshot): boolean {
    const currentUser = JSON.parse(storageService.getItem('token'));
    if (currentUser) {
      let currUser = storageService.getItemAsJSON('currentUser');
      if (route?.data?.role && route?.data?.role.indexOf(currUser?.roles[0]?.name) === -1 && (url.includes('client/feedback') || url.includes('accountant-feedback/speciality'))) {
        this.router.navigate(['/landing-page']);
        return false;
      }
    
      return true;
    }

    // Navigate to the login page with extras
    // this.router.navigate(['/landing-page'], { queryParams: { returnUrl: url } });
    return true;
  }
}
